import { z } from 'zod';

import { itemByLanguage } from './language';

import { BaseReferenceDto } from '@/_generated/api-clients/xp';

const localizedReferenceSchema = z.object({
  icon: z.string(),
});

export const getIconFromReference = (
  reference: Record<string, BaseReferenceDto>,
) => {
  const localizedReference = itemByLanguage(reference);

  const parsedLocalizedReference =
    localizedReferenceSchema.safeParse(localizedReference);

  if (parsedLocalizedReference.success) {
    return parsedLocalizedReference.data.icon;
  }

  return 'Chickfila';
};
